import { useState } from "react";
import { Info, Visibility } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { ICampaignFormState } from "../../App/Typings/Campaigns";
import Modal from "../../App/Components/Modal/Modal";

export default function FormPreviewModal() {
  const [open, setIsOpen] = useState<boolean>(false);
  const { values } = useFormikContext<ICampaignFormState>();
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        data-test="open-form-preview-modal"
        variant="outlined"
        startIcon={<Visibility fontSize="small" />}
        onClick={() => setIsOpen(true)}
      >
        Preview Form
      </Button>
      <Modal
        title="Form Preview"
        isOpen={open}
        handleCloseModal={handleClose}
        dataTestId="form-preview"
        content={
          <iframe
            title="Form Preview"
            src={generateFormPreviewIframe(values)}
            style={{ width: "100%", minHeight: "500px", border: "none" }}
            sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"
          />
        }
        footerContent={
          <Stack direction="row" justifyContent="flex-start" spacing={1} sx={{ width: "100%" }}>
            <Info fontSize="small" color="info" />
            <Typography data-test="form-preview-info" variant="caption">
              This is an <em>unstyled</em> form preview. Submitting the form will not save any data.
            </Typography>
          </Stack>
        }
      />
    </>
  );
}

function generateFormPreviewIframe(values: ICampaignFormState) {
  const escapedJson = encodeURIComponent(JSON.stringify(values));
  const html = `
    <div id="activate-form" data-id="${values.campaignId}" data-form="${values.formId}" data-preview="${escapedJson}"></div>
    <script type="module" src="${import.meta.env.VITE_LEADCAPTURE_FORM}"></script>`;
  return `data:text/html;charset=utf-8,${encodeURIComponent(html)}`;
}
